import React from 'react';
import logo from './logo.svg';
import './App.css';
import Home from './components/Home';
import Skills from './components/Skills';
import Services from './components/Services';
import Portfoliio from './components/Portfoliio';
import About from './components/About';
import Contact from './components/Contact';
import Navbar from './components/Navbar';
import Cursus from './components/Cursus';
import Testimonial from './components/Testimonial';

function App() {
  return (
    <>
      <Navbar/>
      <Home />
      <About />
      <Skills />
      <Portfoliio />
      {/* <Cursus/> */}
      {/* <Services/> */}
      {/* <Testimonial /> */}
      <Contact />
    </>
  );
}

export default App;
